import Vue from "vue";

Vue.directive("lazyload", {
  bind(el, binding) {
    let lazyLoadObser = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        let lazyImage = entry.target;
        if (entry.intersectionRatio > 0) {
          if (binding.value.imgUrl) {
            lazyImage.src = binding.value.imgUrl;
          }
          if (binding.value.animate) {
            el.classList.add(binding.value.animate);
          }
          lazyLoadObser.unobserve(lazyImage);
        }
      });
    });
    lazyLoadObser.observe(el);
  },
});

// 防重复点击(指令实现)
export function applyPreventReClick(el, delay = 1000) {
  let locked = false;
  let disableTimer = null;
  let unlockTimer = null;

  const clearTimers = () => {
    if (disableTimer) {
      clearTimeout(disableTimer);
      disableTimer = null;
    }
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
  };

  const handler = (event) => {
    if (locked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (el.disabled) return;

    locked = true;
    disableTimer = setTimeout(() => {
      el.disabled = true;
    }, 0);
    unlockTimer = setTimeout(() => {
      locked = false;
      el.disabled = false;
      clearTimers();
    }, delay);
  };

  el.addEventListener("click", handler);

  return () => {
    clearTimers();
    el.removeEventListener("click", handler);
  };
}

Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.__preventReClickTeardown__ = applyPreventReClick(
      el,
      binding.value || 1000
    );
  },
  unbind(el) {
    if (el.__preventReClickTeardown__) {
      el.__preventReClickTeardown__();
      delete el.__preventReClickTeardown__;
    }
  },
});
